import orderBy from 'lodash.orderby';
import { isArray, isDefined, isObject } from '../../../utils/isDefined';
import Optional from '../../../utils/optional';

const mapSubscriptions = subs => {
  if (!isArray(subs) || subs.length === 0) {
    return {
      mappedSubscriptions: [],
      mappedWithAllStatuses: []
    };
  }

  const mappedSubscriptions = subs
    .map(sub => {
      const { fromDate, toDate, status } = sub.subscriptionAgreement;
      return {
        ...sub.subscription,
        id: sub.id,
        commercialProduct: sub.commercialProduct?.category,
        technicalProduct: sub.technicalProduct?.category,
        user: sub.accountUser?.name,
        accountName: `${sub.subscription?.account?.name} - ${sub.subscription?.account?.accountNo}`,
        expiryDate: toDate,
        activationDate: fromDate,
        subExpireDate: sub.subscription?.expiryDate,
        agreementStatus: status,
        accountReference: sub.subscription?.account?.externalReference
      };
    })
    .filter(
      sub =>
        isDefined(sub.commercialProduct) && sub.agreementStatus === 'ACTIVE'
    );

  const mappedWithAllStatuses = mappedSubscriptions.map(sub => {
    const filteredSubs = subs
      .filter(el => el.subscription.externalReference === sub.externalReference)
      .map(el => {
        return isObject(el.subscriptionAgreement)
          ? {
              ...el.subscriptionAgreement,
              expiryDate: el.subscriptionAgreement.toDate,
              activationDate: el.subscriptionAgreement.fromDate,
              id: el.id
            }
          : void 0;
      })
      .filter(el => isDefined(el));

    return {
      ...sub,
      all: orderBy(
        filteredSubs,
        ['activationDate', ({ expiryDate }) => Optional(expiryDate).or('')],
        ['desc', 'asc']
      )
    };
  });

  return { mappedSubscriptions, mappedWithAllStatuses };
};

export default mapSubscriptions;
